import React  from 'react';
import { Modal } from 'reactstrap';

import { 
  ContentModal,
  ContentMensajeError
} from "./Estilos";

import { ReturnButton } from "../Buttons/Buttons";

const ModalError = ({titulo, message, icono, data}) => {
  
  return (
    <ContentModal>
      <Modal isOpen={data}>
        <ContentMensajeError>
          <div>
            <i className={icono}></i>
          </div>
          <div>
            <h2>{titulo}</h2>
          </div>
          <div>
            <p>{message}</p>
          </div>

          <div className="row">
            <div className="col-md-6 mx-auto">
              <ReturnButton />
            </div>
          </div>


        </ContentMensajeError>
          
      </Modal>
    </ContentModal>

  )
}

export default ModalError